import LegalParametersView  from '../LegalParametersView.vue'
import LegalParameterList   from '../Pages/LegalParameterList.vue'
import LegalParameterEditor from '../Pages/LegalParameterEditor.vue'

const routes = [
  {
    path: '/mantenimiento/parametros-legales',
    component: LegalParametersView,
    children: [
      { path: '',           name: 'legal-parameter-list',   component: LegalParameterList   },
      { path: 'crear',      name: 'legal-parameter-create', component: LegalParameterEditor },
      { path: ':id/editar', name: 'legal-parameter-edit',   component: LegalParameterEditor },
    ],
  },
]

export default routes
